// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FnBCI","badges":"styles_badges__3519h"};